<mat-sidenav-container fullscreen>
  <mat-sidenav-content>
    <app-header></app-header>

    <div class="main-content contins">


      <!-- offerDesign -->

      <div class="offer_header target">
        <div class="scroll-wrapper">
          <div class="item">
            <a href='#cricket' [routerLink]="[ '/tabgames/1']"><img src="/assets/images/osgbook/ball.svg" id='cricket'
                alt=""></a>
            <p id='cricket'> Cricket</p>
          </div>

          <div class="item">
            <a href='#soccer' [routerLink]="[ '/tabgames/2']" class='target'>
              <img src="/assets/images/osgbook/soccer.svg" id='soccer' alt="">
            </a>
            <p>Soccer</p>
          </div>

          <div class="item">
            <a href='#tennis' [routerLink]="[ '/tabgames/3']" class='target'>
              <img src="/assets/images/osgbook/tennis.svg" id='tennis' alt="">
            </a>
            <p>Tennis</p>
          </div>
          <div class="item">
            <a href='#tabletennis' [routerLink]="[ '/tabgames/13']" class='target'>
              <img src="/assets/images/osgbook/tabletennis.svg" id='tabletennis' alt="">
            </a>
            <p>Table Tennis</p>
          </div>
          <div class="item">
            <a href='#volleyball' [routerLink]="[ '/tabgames/14']" class='target'>
              <img src="/assets/images/osgbook/volleyball.svg" id='volleyball' alt="">
            </a>
            <p>Volleyball</p>
          </div>
          <div class="item">
            <a href='#basketball' [routerLink]="[ '/tabgames/15']" class='target'>
              <img src="/assets/images/osgbook/basketball.svg" id='basketball' alt="">
            </a>
            <p>Basketball</p>
          </div>
          <div class="item" *ngIf="this.kabaddi_menu===true">
            <a href='#kabbadi' [routerLink]="[ '/tabgames/7']" class='target'>
              <img src="/assets/images/osgbook/sports-kabaddi-rounded.svg" id='kabbadi' alt="">
            </a>
            <p>Kabbadi</p>
          </div>
          <div class="item" *ngIf="this.gapcasino_menu===true">
            <a href='#casino' [routerLink]="[ '/tabgames/4']" class='target'>
              <img src="/assets/images/osgbook/cards-header-icon.svg" id='casino' alt="">
            </a>
            <p>Slots</p>
          </div>
          <div class="item" *ngIf="this.gapcasino_menu===true">
            <a href='#casino1' [routerLink]="[ '/tabgames/5']" class='target'>
              <img src="/assets/images/osgbook/chips-header-icon.svg" id='casino1' alt="">
            </a>

            <p>Live Casino</p>
          </div>
          <div class="item" *ngIf="this.gapcasino_menu===true">
            <a href='#casino2' [routerLink]="[ '/tabgames/6']" class='target'>
              <img src="/assets/images/osgbook/dice-header-icon.svg" id='casino2' alt="">
            </a>
            <p>Casino</p>
          </div>
          <div class="item" *ngIf="this.Contest_menu===true">
            <a href='#contest' [routerLink]="['/tabgames/8']" class='target'>
              <img src="/assets/images/osgbook/dailycontest.svg" id='contest' alt="">
            </a>
            <p>Contest</p>
          </div>
          <div class="item" *ngIf="this.playerbattle_menu===true">
            <a href='#playerbattle' [routerLink]="['/tabgames/9']" class='target'>
              <img src="/assets/images/osgbook/playerbattle.svg" id='playerbattle' alt="">
            </a>
            <p>Player Battle</p>
          </div>
          <div class="item">
            <a href='#tournament' [routerLink]="[ '/tabgames/11']" class='target'>
              <img src="/assets/images/osgbook/trophy.svg" id='tournament' alt="">
            </a>
            <p>Tournaments</p>
          </div>
          <!-- <div class="item" >
          <a href='#horse' [routerLink]="[ '/tabgames/10']"  class='target'>
            <img src="/assets/images/osgbook/horse-racing.svg" id='horse' alt="">
          </a>
          <p>Horse Racing</p>
        </div>
        <div class="item" >
          <a href='#greyhound' [routerLink]="[ '/tabgames/12']"  class='target'>
            <img src="/assets/images/osgbook/greyhound.svg" id='greyhound' alt="">
          </a>
          <p>Greyhound Racing</p>
        </div>       -->
        </div>
      </div>

      <!-- banner -->

      <!-- bannerEnd -->
      <div style="margin-bottom: 80px;">
      </div>

      <div *ngIf="allMessages?.length" class="marquee-text">
        <marquee width="100%" direction="left">
          {{ allMessages.join(" | ") }}
        </marquee>
      </div>
      <ng-container *ngIf="this.ballbycricket===true && isInPlayRoute()">
        <div class="game-list-card">
          <div class="game-list-header">
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
            Ball By Ball
            <!-- ({{virtualCricketData?.length}}) -->
            <mat-divider class="didvide" [vertical]="true"></mat-divider>
          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr class="bordertbl" [routerLink]="['/ballbyball-detail']">
              <td class="borderright">
                <div class="time-daynew inplay-btn">In-play</div>
                <!-- <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                    <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                      {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                      {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                  </div> -->
              </td>
              <td class="borderright">
                <span class="headerinplay" style="padding-left: 6px;">Ball By Ball</span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span>2.18<br />
                    <small>0 </small>
                  </span>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span>2.59<br />
                    <small>0</small>
                  </span>

                </div>
              </td>
            </tr>
          </table>

        </div>
      </ng-container>
      <ng-container *ngIf="this.virtuallog && isInPlayRoute()">
        <div class="game-list-card">
          <div class="game-list-header">
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
            Virtual Cricket
            <!-- ({{virtualCricketData?.length}}) -->
            <mat-divider class="didvide" [vertical]="true"></mat-divider>
          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr (click)="virtualDetial('1234822733', 'v9');" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn">In-play</div>
                <div class="time-daynew">
                  <span class="bet-datetime">

                    <br>
                  </span>
                </div>
              </td>
              <td class="borderright">
                <span class="headerinplay" style="padding-left: 6px;">SriLanka vs WestIndies</span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span>1.90<br />
                    <small> 0.00</small>
                  </span>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span>1.90<br />
                    <small>0.00</small>
                  </span>

                </div>
              </td>
            </tr>
          </table>
          <!-- <mat-card *ngFor="let x of virtualCricketData" class="match-event-list m-1"
              (click)="virtualDetial(x.eventId);">

             
              <div class="match-name" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                <div class="time-day inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-Play</div>
                <div class="time-day" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
                <img src="assets/images/icon/cricket.svg">
                <div class="odd-content">
                  <div class="odd-title">
                    <b>{{x?.eventName}}</b>
                  </div>
                </div>
              </div>
              <div class="event-odds" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                <div class="match-rate">
                  <div class="odd-list back-rate back-1">{{x?.marketBook?.runners[0]?.availableToBack?.price}}</div>
                  <div class="odd-list lay-rate lay-1">{{x?.marketBook?.runners[0]?.availableToLay?.price}}</div>
                  <div class="odd-list back-rate back-2">--</div>
                  <div class="odd-list lay-rate lay-2">--</div>
                  <div class="odd-list back-rate back-3">
                    {{x?.marketBook?.runners[1]?.availableToBack?.price}}</div>
                  <div class="odd-list lay-rate lay-3">
                    {{x?.marketBook?.runners[1]?.availableToLay?.price}}</div>
                </div>
              </div>
            </mat-card> -->
        </div>
      </ng-container>
      <!---Playerbattle and contest-->
      <ng-container *ngIf="isInPlaybatle()">
        <div class="img-grid" *ngIf="this.playerbattle_menu || this.Contest_menu">
          <div class="img-box" *ngIf="this.Contest_menu===true">
            <a [routerLink]="[ '/tabgames/8']"> <img src="../../assets/images/cont.png" alt="" class="imags"></a>
          </div>
          <div class="img-box" *ngIf="this.playerbattle_menu===true">
            <a [routerLink]="[ '/tabgames/9']"> <img src="../../assets/images/Player-Battle.png" alt=""
                class="imags"></a>
          </div>
        </div>
      </ng-container>
      <ng-conatainer *ngIf="this.gapcasino_menu && isInPlaybatle()">
        <app-casino-provider></app-casino-provider>
      </ng-conatainer>
      <div>

      </div>
      <!---end-->
      <!-- Cricket -->
      <ng-container id="cricket" *ngIf="cricketData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Cricket
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/1']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <td>

              </td>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of cricketData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else cric0back">{{x?.marketBook?.runners[0]?.availableToBack?.price
                    }}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #cric0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else cric0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #cric0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
            </tr>
          </table>
          <!-- <mat-card *ngFor="let x of cricketData" class="match-event-list m-1" (click)="matchDetail(x.eventId);">

              <div class="match-name" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                <div class="time-day inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-Play</div>
                <div class="time-day" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
                <img src="assets/images/icon/cricket.svg">
                <div class="odd-content">
                  <div class="odd-title">
                    <b>{{x?.eventName}}</b>


                  </div>
                </div>
              </div>
              <div class="event-odds" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                <div class="match-rate">
                  <div class="odd-list back-rate back-1">{{x?.marketBook?.runners[0]?.availableToBack?.price}}</div>
                  <div class="odd-list lay-rate lay-1">{{x?.marketBook?.runners[0]?.availableToLay?.price}}</div>
                  <div class="odd-list back-rate back-2">--</div>
                  <div class="odd-list lay-rate lay-2">--</div>
                  <div class="odd-list back-rate back-3">
                    {{x?.marketBook?.runners[1]?.availableToBack?.price}}</div>
                  <div class="odd-list lay-rate lay-3">
                    {{x?.marketBook?.runners[1]?.availableToLay?.price}}</div>
                </div>
              </div>
            </mat-card> -->
        </div>
      </ng-container>
      <!-- Soccer -->
      <ng-container *ngIf="soccerData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Soccer
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/2']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of soccerData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else socc0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #socc0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else socc0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #socc0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
            </tr>
          </table>
          <!-- <mat-card *ngFor="let x of soccerData" class="match-event-list m-1" (click)="matchDetail(x.eventId);">
        
                      
                      <div class="match-name" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                        <div class="time-day inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-Play</div>
                        <div class="time-day" *ngIf="!checkInplayStatus(x.openDate)">
                          <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                        </div>
                        <img src="assets/images/icon/soccer.svg">
                        <div class="odd-content">
                          <div class="odd-title">
                            <b>{{x?.eventName}}</b>
                          </div>
                        </div>
                      </div>
                      <div class="event-odds" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
                        <div class="match-rate">
                          <div class="odd-list back-rate back-1">{{x?.marketBook?.runners[0]?.availableToBack?.price}}</div>
                          <div class="odd-list lay-rate lay-1">{{x?.marketBook?.runners[0]?.availableToLay?.price}}</div>
                          <div class="odd-list back-rate back-2">--</div>
                          <div class="odd-list lay-rate lay-2">--</div>
                          <div class="odd-list back-rate back-3">
                            {{x?.marketBook?.runners[1]?.availableToBack?.price}}</div>
                          <div class="odd-list lay-rate lay-3">
                            {{x?.marketBook?.runners[1]?.availableToLay?.price}}</div>
                        </div>
                       
                      </div>
        
                    </mat-card> -->
        </div>
      </ng-container>
      <!-- Tennis -->
      <ng-container *ngIf="tennisData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Tennis
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/3']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of tennisData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else tennis0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #tennis0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else tennis0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #tennis0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>

                </div>
              </td>
            </tr>
          </table>
          <!-- <mat-card *ngFor="let x of tennisData" class="match-event-list m-1" (click)="matchDetail(x.eventId);">

     
      <div class="match-name" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
        <div class="time-day inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-Play</div>
        <div class="time-day" *ngIf="!checkInplayStatus(x.openDate)">
          <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
            {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
        </div>
        <img src="assets/images/icon/tennis.svg">
        <div class="odd-content">
          <div class="odd-title">
            <b>{{x?.eventName}}</b>
          </div>
        </div>
      </div>
      <div class="event-odds" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
        <div class="match-rate">
          <div class="odd-list back-rate back-1">{{x?.marketBook?.runners[0]?.availableToBack?.price}}</div>
          <div class="odd-list lay-rate lay-1">{{x?.marketBook?.runners[0]?.availableToLay?.price}}</div>
          <div class="odd-list back-rate back-2">--</div>
          <div class="odd-list lay-rate lay-2">--</div>
          <div class="odd-list back-rate back-3">
            {{x?.marketBook?.runners[1]?.availableToBack?.price}}</div>
          <div class="odd-list lay-rate lay-3">
            {{x?.marketBook?.runners[1]?.availableToLay?.price}}</div>
        </div>

    </mat-card> -->
        </div>

      </ng-container>
      <!-- kabbadi -->
      <ng-container *ngIf="kabbadiData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Kabbadi
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/7']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>

          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of kabbadiData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else kabbadi0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #kabbadi0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else kabbadi0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #kabbadi0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>

                </div>
              </td>
            </tr>
          </table>

        </div>

      </ng-container>
      <ng-container *ngIf="tableTennisData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Table Tennis
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/13']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of tableTennisData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else tennis0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #tennis0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else tennis0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #tennis0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>

                </div>
              </td>
            </tr>
          </table>
          <!-- <mat-card *ngFor="let x of tennisData" class="match-event-list m-1" (click)="matchDetail(x.eventId);">

     
      <div class="match-name" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
        <div class="time-day inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-Play</div>
        <div class="time-day" *ngIf="!checkInplayStatus(x.openDate)">
          <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
            {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
        </div>
        <img src="assets/images/icon/tennis.svg">
        <div class="odd-content">
          <div class="odd-title">
            <b>{{x?.eventName}}</b>
          </div>
        </div>
      </div>
      <div class="event-odds" fxLayout="row" fxLayoutAlign="start space-arround" fxLayoutGap="5px">
        <div class="match-rate">
          <div class="odd-list back-rate back-1">{{x?.marketBook?.runners[0]?.availableToBack?.price}}</div>
          <div class="odd-list lay-rate lay-1">{{x?.marketBook?.runners[0]?.availableToLay?.price}}</div>
          <div class="odd-list back-rate back-2">--</div>
          <div class="odd-list lay-rate lay-2">--</div>
          <div class="odd-list back-rate back-3">
            {{x?.marketBook?.runners[1]?.availableToBack?.price}}</div>
          <div class="odd-list lay-rate lay-3">
            {{x?.marketBook?.runners[1]?.availableToLay?.price}}</div>
        </div>

    </mat-card> -->
        </div>

      </ng-container>
      <ng-container *ngIf="volleyballData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Volleyball
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/14']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of volleyballData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else volley0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #volley0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else volley0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #volley0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>

                </div>
              </td>
            </tr>
          </table>
        </div>

      </ng-container>
      <ng-container *ngIf="basketballData?.length">
        <div class="game-list-card">
          <div class="game-list-header">
            <table>
              <tr>
                <th>
                  Basketball
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </th>
                <th style="text-align: right;">
                  <a [routerLink]="[ '/tabgames/15']"> <span style="color:#3a3737d4">View All</span>
                  </a>
                </th>
              </tr>
            </table>
            <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

            <!-- ({{cricketData?.length}}) -->


          </div>
          <table class="tabledata">
            <tr>
              <th class="inplayrate">
                <i class="material-icons iconpadd">schedule</i>
              </th>
              <th class="headerinplay ">Team</th>
              <th></th>
              <th class="inplayrate">Back</th>
              <th class="inplayrate">Lay</th>
            </tr>
            <tr *ngFor="let x of basketballData" (click)="matchDetail(x.eventId, x.eventTypeId);" class="bordertbl">
              <td class="borderright">
                <div class="time-daynew inplay-btn" *ngIf="checkInplayStatus(x.openDate)">In-play</div>
                <div class="time-daynew" *ngIf="!checkInplayStatus(x.openDate)">
                  <span class="bet-datetime">{{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                    {{moment(x?.openDate).utcOffset("+05:30").format('D')}} <br>
                    {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}</span>
                </div>
              </td>
              <td style="padding-left: 8px;line-height: 12px;">
                <span class="headerinplay">{{x?.eventName}}</span>
              </td>
              <td>
                <span class="live-tv-icon" *ngIf="x.marketBook.inplay == true">
                  <mat-icon>slideshow</mat-icon>
                </span>
              </td>
              <td class="inplayrate ">
                <div class="odd-list back-rate back-1">
                  <span
                    *ngIf="x.marketBook.runners[0].availableToBack; else basket0back">{{x?.marketBook?.runners[0]?.availableToBack?.price}}<br />
                    <small> {{x?.marketBook?.runners[0]?.availableToBack?.size}}</small>
                  </span>
                  <ng-template #basket0back>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>
                </div>
              </td>
              <td class="inplayrate borderright">
                <div class="odd-list lay-rate lay-1"><span
                    *ngIf="x.marketBook.runners[0].availableToLay; else basket0lay">{{x?.marketBook?.runners[0]?.availableToLay?.price}}<br />
                    <small>{{x?.marketBook?.runners[0]?.availableToLay?.size}}</small>
                  </span>
                  <ng-template #basket0lay>
                    <span>
                      -<br />
                      <small>-</small>
                    </span>
                  </ng-template>

                </div>
              </td>
            </tr>
          </table>
        </div>

      </ng-container>

      <div style="margin-bottom: 8px;"></div>
      <div *ngIf="dataLength">
        <ng-container *ngIf="!inplay">
          <div class="game-list-card">
            <div class="game-list-header">
              <table>
                <tr>
                  <th>
                    Diamond Table
                    <mat-divider class="didvide" [vertical]="true"></mat-divider>
                  </th>
                  <th style="text-align: right;">
                    <a [routerLink]="[ '/diamondlist']"> <span style="color:#3a3737d4">View All</span>
                    </a>
                  </th>
                </tr>
              </table>
              <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

              <!-- ({{cricketData?.length}}) -->


            </div>
            <ul class="casinolistgrid">

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3457
                  </div>
                  <img class="imgsize" (click)="openDaimond('teen')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/teen.jpg" alt="">


                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      Teepatti 1 day
                    </p>
                    <!-- <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p> -->
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5332
                  </div>
                  <img class="imgsize" (click)="openDaimond('teen9')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/teen9.jpg" alt="">

                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      Teenpatti Test
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 55376
                  </div>
                  <img class="imgsize" (click)="openDaimond('poker')"
                    src="https://dataobj.ecoassetsservice.com/casino-icons/lc/poker.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      Poker 1 Day
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 8151
                  </div>
                  <img class="imgsize" (click)="openDaimond('dt20')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/dt20.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      20-20 Dragon Tiger
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 111
                  </div>
                  <img class="imgsize" (click)="openDaimond('teen20')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/teen20.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      20-20 Teenpatti
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2220
                  </div>
                  <img class="imgsize" (click)="openDaimond('teen8')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/teen8.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      20-20 Teenpatti
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2388
                  </div>
                  <img class="imgsize" (click)="openDaimond('lucky7')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/lucky7.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      Lucky 7A
                    </p>

                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 904
                  </div>
                  <img class="imgsize" (click)="openDaimond('cmatch20')"
                    src="https://nd.sprintstaticdata.com/casino-icons/lc/cmatch20.jpg" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Diamond
                    </p>
                    <p class="namecasinom">
                      Circket Match 20-20
                    </p>

                  </div>
                </div>
              </li>
            </ul>

          </div>
          <div class="game-list-card" *ngIf="this.gapcasino_menu">
            <div class="game-list-header">
              <table>
                <tr>
                  <th>
                    Slots
                    <mat-divider class="didvide" [vertical]="true"></mat-divider>
                  </th>
                  <th style="text-align: right;">
                    <a [routerLink]="[ '/tabgames/4']"> <span style="color:#3a3737d4">View All</span>
                    </a>
                  </th>
                </tr>
              </table>
              <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

              <!-- ({{cricketData?.length}}) -->


            </div>
            <ul class="casinolistgrid">
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3938
                  </div>
                  <img class="imgsize" (click)="opengapss('335001')"
                    src="https://cdn.dreamdelhi.com/fiesta777/fish frenzy quickex.png" alt="">

                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Fish Frenzy
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 9376
                  </div>
                  <img class="imgsize" (click)="opengapss('335002')"
                    src="https://cdn.dreamdelhi.com/fiesta777/spooky for quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Spooky Reels
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 8171
                  </div>
                  <img class="imgsize" (click)="opengapss('335003')"
                    src="https://cdn.dreamdelhi.com/fiesta777/Jelly Jackpot quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Jelly Jackpot
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 170
                  </div>
                  <img class="imgsize" (click)="opengapss('335004')"
                    src="https://cdn.dreamdelhi.com/fiesta777/Gummy blast quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Gummy Blast
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2097
                  </div>
                  <img class="imgsize" (click)="opengapss('335005')"
                    src="https://cdn.dreamdelhi.com/fiesta777/candyclash quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Candy Clash
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3488
                  </div>
                  <img class="imgsize" (click)="opengapss('335006')"
                    src="https://cdn.dreamdelhi.com/fiesta777/fishing fortune quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Fishing Fortune
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 341
                  </div>
                  <img class="imgsize" (click)="opengapss('335007')"
                    src="https://cdn.dreamdelhi.com/fiesta777/salsa sizzle quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Salsa Sizzle
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5674
                  </div>
                  <img class="imgsize" (click)="opengapss('335008')"
                    src="https://cdn.dreamdelhi.com/fiesta777/divine reckoning quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Divine Reckoning
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 5L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3070
                  </div>
                  <img class="imgsize" (click)="opengapss('335009')"
                    src="https://cdn.dreamdelhi.com/fiesta777/puppy clash quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Puppy Clash
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5074
                  </div>
                  <img class="imgsize" (click)="opengapss('335010')"
                    src="https://cdn.dreamdelhi.com/fiesta777/lunar howl quickex.png" alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Slot Games
                    </p>
                    <p class="namecasinom">
                      Lunar Howl
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 3L
                    </p>
                  </div>
                </div>
              </li>

            </ul>

          </div>
          <div class="game-list-card" *ngIf="this.gapcasino_menu">
            <div class="game-list-header">
              <table>
                <tr>
                  <th>
                    Live Casino
                    <mat-divider class="didvide" [vertical]="true"></mat-divider>
                  </th>
                  <th style="text-align: right;">
                    <a [routerLink]="[ '/tabgames/5']"> <span style="color:#3a3737d4">View All</span>
                    </a>
                  </th>
                </tr>
              </table>
              <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->

              <!-- ({{cricketData?.length}}) -->


            </div>

            <ul class="casinolistgrid">

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 9954
                  </div>

                  <img class="imgsize" (click)="opengapss('150000')"
                    src="https://cdn.dreamdelhi.com/mac88/lobby_mac88.webp" alt="Mac88 Gaming Lobby" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Mac88 Gaming Lobby
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 7467
                  </div>

                  <img class="imgsize" (click)="opengapss('150001')" src="https://cdn.mac88.com/mac88/dt_mac88.webp"
                    alt="Dragon Tiger" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Dragon Tiger
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 7668
                  </div>

                  <img class="imgsize" (click)="opengapss('150002')"
                    src="https://cdn.mac88.com/mac88/baccarat_mac88.webp" alt="Bacarrat" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Bacarrat
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5676
                  </div>

                  <img class="imgsize" (click)="opengapss('150003')" src="https://cdn.mac88.com/mac88/sicbo_mac88.webp"
                    alt="Sic Bo" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Sic Bo
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 9880
                  </div>

                  <img class="imgsize" (click)="opengapss('150004')"
                    src="https://cdn.mac88.com/mac88/roulette_mac88.webp" alt="Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 1703
                  </div>

                  <img class="imgsize" (click)="opengapss('150005')" src="https://cdn.mac88.com/mac88/20_20_poker.webp"
                    alt="Poker 20-20" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Poker 20-20
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2107
                  </div>

                  <img class="imgsize" (click)="opengapss('150006')" src="https://cdn.mac88.com/mac88/lucky_7.webp"
                    alt="Lucky7" />

                  <div class="game-detail">
                    <p class="namecasino">
                      Mac88 Gaming
                    </p>

                    <p class="namecasinom">
                      Lucky7
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    9954
                  </div>

                  <img class="imgsize" (click)="opengapss('860001')" src="https://cdn.dreamcasino.live/sbe_aviator.webp"
                    alt="Aviator" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Aviator
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Dice -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    7467
                  </div>

                  <img class="imgsize" (click)="opengapss('860002')" src="https://cdn.dreamcasino.live/sbe_dice.webp"
                    alt="Dice" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Dice
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Goal -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    7668
                  </div>

                  <img class="imgsize" (click)="opengapss('860003')" src="https://cdn.dreamcasino.live/sbe_goal.webp"
                    alt="Goal" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Goal
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Plinko -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    5676
                  </div>

                  <img class="imgsize" (click)="opengapss('860004')" src="https://cdn.dreamcasino.live/sbe_plinko.webp"
                    alt="Plinko" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Plinko
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Mines -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    9880
                  </div>

                  <img class="imgsize" (click)="opengapss('860005')" src="https://cdn.dreamcasino.live/sbe_mines.webp"
                    alt="Mines" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Mines
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Hi Lo -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    1703
                  </div>

                  <img class="imgsize" (click)="opengapss('860006')" src="https://cdn.dreamcasino.live/sbe_hilo.webp"
                    alt="Hi Lo" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Hi Lo
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>

              <!-- Keno -->
              <li>
                <div class="imgframe">

                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon>
                    2107
                  </div>

                  <img class="imgsize" (click)="opengapss('860007')" src="https://cdn.dreamcasino.live/sbe_keno.webp"
                    alt="Keno" />

                  <div class="game-detail">
                    <p class="namecasino">
                      SPRIBE
                    </p>

                    <p class="namecasinom">
                      Keno
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>

                </div>
              </li>
            </ul>



          </div>
          <!-- <div class="game-list-card">
            <div class="game-list-header">
              <table>
                <tr>
                  <th>
                    Casino
                    <mat-divider class="didvide" [vertical]="true"></mat-divider>
                  </th>
                  <th style="text-align: right;">
                    <a [routerLink]="[ '/tabgames/6']"> <span style="color:#3a3737d4">View All</span>
                    </a>
                  </th>
                </tr>
              </table>

            </div>
            <ul class="casinolistgrid">
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 6043
                  </div>
                  <img class="imgsize" *ngIf="this.aviatorlog===true ; else adedid" [routerLink]="['/aviator-page']"
                    src="https://cdn.dreamcasino.live/sbe_aviator.webp" alt="">

                  <ng-template #adedid>
                    <img class="imgsize"
                      src="https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=logo-square&version=1671525105358"
                      alt="">
                  </ng-template>

                  <div class="game-detail">
                    <p class="namecasino">
                      Spribe
                    </p>
                    <p class="namecasinom">
                      Aviator
                    </p>
                    <p class="namecasino bottomi">
                      ₹10 - 8K
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 6880
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-teenpatti')"
                    src="https://client.qtlauncher.com/images/?id=EZU-teenpatti_en_US&type=logo-square&version=1678549135880"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Ezugi
                    </p>
                    <p class="namecasinom">
                      Teen Patti
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 40K
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5099
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-andarbahar')"
                    src="https://client.qtlauncher.com/images/?id=EZU-andarbahar_en_US&type=logo-square&version=1678476979546"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Ezugi
                    </p>
                    <p class="namecasinom">
                      Andar Bahar
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 50K
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2124
                  </div>
                  <img class="imgsize" (click)="openCasino('EVO-megaball')"
                    src="https://client.qtlauncher.com/images/?id=EVO-megaball_en_US&type=logo-square&version=1678386402736"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Evolution Gaming
                    </p>
                    <p class="namecasinom">
                      Mega Ball
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 20K
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3963
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-onedayteenpatti')"
                    src="https://client.qtlauncher.com/images/?id=EZU-onedayteenpatti_en_US&type=logo-square&version=1678548013373"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Ezugi
                    </p>
                    <p class="namecasinom">
                      One Day Teen Patti
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 1L
                    </p>
                  </div>

                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 1690
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-lucky7')"
                    src="https://client.qtlauncher.com/images/?id=EZU-lucky7_en_US&type=logo-square&version=1678547615073"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Ezugi
                    </p>
                    <p class="namecasinom">
                      Lucky 7
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 1L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 1553
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-threecardpoker')"
                    src="https://client.qtlauncher.com/images/?id=EVO-sidebetcity_en_US&type=logo-square&version=1678388046310"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Evolution Gaming
                    </p>
                    <p class="namecasinom">
                      Side Bet City
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 8955
                  </div>
                  <img class="imgsize" (click)="openCasino('EZU-threecardpoker')"
                    src="https://client.qtlauncher.com/images/?id=EZU-threecardpoker_en_US&type=logo-square&version=1687280164981"
                    alt="">
                  <div class="game-detail">
                    <p class="namecasino">
                      Ezugi
                    </p>
                    <p class="namecasinom">
                      Three Card Poker
                    </p>
                    <p class="namecasino bottomi">
                      ₹100 - 1L
                    </p>
                  </div>
                </div>
              </li>
            </ul>

          </div> -->

          <div class="game-list-card" *ngIf="this.gapcasino_menu">
            <div class="game-list-header">
              <table>
                <tr>
                  <th>
                    Casino
                    <mat-divider class="didvide" [vertical]="true"></mat-divider>
                  </th>
                  <th style="text-align: right;">
                    <a [routerLink]="[ '/tabgames/6']"> <span style="color:#3a3737d4">View All</span>
                    </a>
                  </th>
                </tr>
              </table>
            </div>

            <ul class="casinolistgrid">
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 6043
                  </div>
                  <img class="imgsize" *ngIf="this.aviatorlog===true ; else adedid" [routerLink]="['/aviator-page']"
                    src="https://cdn.dreamcasino.live/sbe_aviator.webp" alt="">

                  <ng-template #adedid>
                    <img class="imgsize"
                      src="https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=logo-square&version=1671525105358"
                      alt="">
                  </ng-template>

                  <div class="game-detail">
                    <p class="namecasino">
                      Spribe
                    </p>
                    <p class="namecasinom">
                      Aviator
                    </p>
                    <p class="namecasino bottomi">
                      ₹10 - 8K
                    </p>
                  </div>
                </div>
              </li>
              <!-- Blackjack Gold 5 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 9954
                  </div>

                  <img class="imgsize" (click)="opengapss('100001')"
                    src="https://cdn.dreamcasino.live/ezugi/ezg_blackjackgold5.webp" alt="Blackjack Gold 5" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Blackjack Gold 5
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Blackjack Gold 4 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 7467
                  </div>

                  <img class="imgsize" (click)="opengapss('100002')"
                    src="http://cdn.dreamcasino.live/gold_blackjack_4.webp" alt="Blackjack Gold 4" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Blackjack Gold 4
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Blackjack Gold 3 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 7668
                  </div>

                  <img class="imgsize" (click)="opengapss('100005')"
                    src="https://cdn.dreamcasino.live/gold_blackjack_1.webp" alt="Blackjack Gold 3" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Blackjack Gold 3
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Blackjack Gold 1 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5676
                  </div>

                  <img class="imgsize" (click)="opengapss('100006')"
                    src="https://cdn.dreamcasino.live/gold_blackjack_2.webp" alt="Blackjack Gold 1" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Blackjack Gold 1
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- VIP Blackjack with Surrender -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 9880
                  </div>

                  <img class="imgsize" (click)="opengapss('100009')"
                    src="https://cdn.dreamcasino.live/ezugi/vip-bj-surrender-thumb-v2.webp"
                    alt="VIP Blackjack with Surrender" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      VIP Blackjack with Surrender
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- VIP Blackjack -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 1703
                  </div>

                  <img class="imgsize" (click)="opengapss('100010')"
                    src="https://cdn.dreamcasino.live/ezugi/vip-bj-thumb-v2.webp" alt="VIP Blackjack" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      VIP Blackjack
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Rumba Blackjack 2 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2107
                  </div>

                  <img class="imgsize" (click)="opengapss('100013')"
                    src="https://cdn.dreamcasino.live/rumba_blackjack_2.webp" alt="Rumba Blackjack 2" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Rumba Blackjack 2
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Unlimited Blackjack -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 6543
                  </div>

                  <img class="imgsize" (click)="opengapss('100022')"
                    src="https://cdn.dreamcasino.live/ezugi/ezg_unlimitedblackjack.webp" alt="Unlimited Blackjack" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Unlimited Blackjack
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Mambo Unlimited Blackjack -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 4321
                  </div>

                  <img class="imgsize" (click)="opengapss('100024')"
                    src="https://cdn.dreamcasino.live/ezugi/440x528+ubj++es.webp" alt="Mambo Unlimited Blackjack" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Mambo Unlimited Blackjack
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Italian Roulette -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3876
                  </div>

                  <img class="imgsize" (click)="opengapss('100026')"
                    src="https://cdn.dreamcasino.live/italian roulette.webp" alt="Italian Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Italian Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Speed Roulette -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5210
                  </div>

                  <img class="imgsize" (click)="opengapss('100027')"
                    src="https://cdn.dreamcasino.live/speed_roulette_221000.webp" alt="Speed Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Speed Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Diamond Roulette -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 6432
                  </div>

                  <img class="imgsize" (click)="opengapss('100028')"
                    src="https://cdn.dreamcasino.live/ezugi/diamond-roulette-thumb-v2.webp" alt="Diamond Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Diamond Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Namaste Roulette -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 7654
                  </div>

                  <img class="imgsize" (click)="opengapss('100029')"
                    src="https://cdn.dreamcasino.live/ezugi/namaste-roulette-thumb-v2.webp" alt="Namaste Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Namaste Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Cumbia Ruleta 1 -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 4325
                  </div>

                  <img class="imgsize" (click)="opengapss('100030')"
                    src="https://cdn.dreamcasino.live/ezugi/ezg_cumbiaruleta1.webp" alt="Cumbia Ruleta 1" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Cumbia Ruleta 1
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Türkçe Rulet -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 3987
                  </div>

                  <img class="imgsize" (click)="opengapss('100031')"
                    src="https://cdn.dreamcasino.live/turkish_roulette.webp" alt="Türkçe Rulet" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Türkçe Rulet
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Ruletka Russia -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 2876
                  </div>

                  <img class="imgsize" (click)="opengapss('100032')"
                    src="https://cdn.dreamcasino.live/ruletka russia.webp" alt="Ruletka Russia" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Ruletka Russia
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

              <!-- Automatic Roulette -->
              <li>
                <div class="imgframe">
                  <div class="usercount">
                    <mat-icon class="material-icons sizecasino">people</mat-icon> 5432
                  </div>

                  <img class="imgsize" (click)="opengapss('100034')"
                    src="https://cdn.dreamcasino.live/ezugi/auto-roulette-thumbb.webp" alt="Automatic Roulette" />

                  <div class="game-detail">
                    <p class="namecasino">
                      EZUGI
                    </p>

                    <p class="namecasinom">
                      Automatic Roulette
                    </p>

                    <p class="namecasino bottomi">
                      ₹100 - 2L
                    </p>
                  </div>
                </div>
              </li>

            </ul>

          </div>

        </ng-container>

      </div>




      <!-- <ng-container>
          <div *ngIf="!inplay" >
            <div class="row">
              <div class="col-12">
                <h3>Trending</h3>
              </div>
              <div class="col-6">
                <div class="t-img" *ngIf="avaialablePlayBattle!=-1"> <img class="w-100" routerLink="/player-battle"
                    src="/assets/images/playbettal.jfif" alt=""></div>
              </div>
              <div class="col-6">
                <div class="t-img" *ngIf="avaialableContest!=-1"> <img class="w-100" routerLink="/player-contest"
                    src="/assets/images/daily-contest.jfif" alt=""></div>
              </div>
            </div>
          </div>
    
          <div *ngIf="!inplay" class="sectiontrending">
    
            <div class="row">
              <div class="col-6">
                <h3>Wheel Spinner</h3>
                <div class="t-img"> <img class="w-100" routerLink="/wheel-spinner" src="/assets/images/spinwin.jfif" alt="">
                </div>
              </div>
              <div class="col-6">
                <h3 *ngIf="userDetails?.details?.manager!='OSG365'">InPlay</h3>
                <h3 *ngIf="userDetails?.details?.manager=='OSG365'">Virtual</h3>
                <div *ngIf="userDetails?.details?.manager=='OSG365'" class="t-img"> <img class="w-100" (click)="virtualDetial('1234822733')" src="/assets/images/virtual.JPEG"
                  alt=""></div>
                <div *ngIf="userDetails?.details?.manager!='OSG365'" class="t-img"> <img class="w-100" routerLink="/dashboard/inplay" src="/assets/images/bating.png"
                  alt=""></div>
                
              </div>

            </div>
            <div class="row" *ngIf="userDetails?.details?.manager!='OSG365'">
              <div class="col-12">
                <h3>Casino</h3>
              </div>
              <div class="col-3 t-img2">
                <div> <img class="w-100" (click)="openCasino('SPB-aviator')" src="/assets/images/aviator.png"
                    alt=""></div>
              </div>
              <div class="col-3 t-img2">
                <div> <img class="w-100" (click)="openCasino('BPG-jackpotinthebox')" src="/assets/images/download.png"
                    alt=""></div>
              </div>
              <div class="col-3 t-img2">
                <div> <img class="w-100" (click)="openCasino('1x2-coinfield')" src="/assets/images/download2.png"
                    alt=""></div>
              </div>
              <div class="col-3 t-img2">
                <div> <img class="w-100" (click)="openCasino('DS-aceydeucey')" src="/assets/images/download3.png"
                    alt=""></div>
              </div>
            </div>
    
          </div>
        </ng-container> -->





      <div *ngIf="offer_data?.length>0 && tokenCheck" class="container offer_icon"
        style="background:url(/assets/background/offer_back.jpg);background-size: cover;background-repeat: no-repeat;background-position: center center;min-height:21vh;">
        <div class="row mx-1">
          <span class="col-12"><i class="fas fa-light fa-gifts"></i><br>
            <h2>BOUNS ON YOUR DEPOSITE</h2>
          </span>
          <ng-container *ngFor="let x of offer_data">
            <div class="col-6">{{x?.percentage}}%</div>
            <div class="col-6">Greter then &#8377;{{x?.amount}}</div>
          </ng-container>
        </div>


      </div>

      <!-- casinoImg -->
      <!-- <ng-container *ngIf="tokenCheck && dataLength">
        <div class="multi-card">
          <div class="scroll-card" style="padding: 14px;">
            <div class="itemsContain">
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/85246d801fef4d43a325637243661631_neon-thumbnails-18.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/912af3fca2144874b7b7ab2de03cf63a_neon-thumbnails-13.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group" style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>

              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/0730f21c63544456a0fa1eb250ae4992_neon-thumbnails-17.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/e910c519f92c41a58a9c59dc09e11250_neon-thumbnails-14.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/da0706276b4444d491846159bb1bf07a_neon-thumbnails-09.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/1afe8e32eb0d43a496d56979bf5e8b60_neon-thumbnails-10.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/89685a59c2dc46429b805875c37066a6_neon-thumbnails-16.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/8e0efab978a14ed483a794f9bb71ff96_neon-thumbnails-19.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/d67c61187ab248a58aefdeceff2edd96_neon-thumbnails-06.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/f42e05b9dcee4275b3e2addc2f73c606_neon-thumbnails-08.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>

              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/c33323b773474acf9f3c43b33e31ae91_neon-thumbnails-12.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/6fbb02d51cf044ea856eaa77faa77cd6_neon-thumbnails-15.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/23bce1903ca24717bfa7e6958f026aee_neon-thumbnails-07.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/2b26c9bd6797460dae6697ee093b0825_neon-thumbnails-05.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/2594257625a948feaf82aee8447a8cfc_23-RNG-queen.jpg" class="card-img-top"
                    alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

                <div class="card">
                  <img src="assets/images/casino/198dec4fe9634a0493825705892cbd1f_neon-thumbnails-11.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>
              <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
                <div class="card">
                  <img src="assets/images/casino/c88fc9c1bfc34e97b8e96a80007e34cf_neon-thumbnails-01.png"
                    class="card-img-top" alt="...">
                  <div class="button"><a href="#"> Play Now</a></div>
                </div>

              </div>

            </div>

          </div>

        </div>
      </ng-container> -->
      <!-- casinoImgEnd -->

      <!-- offerDesign end-->

      <div class="dashboard-page">

        <!-- casinoFooter -->
        <ng-container *ngIf="tokenCheck && dataLength">
          <!-- footer -->
          <footer class="text-center text-white" style="background:#fff;">
            <!-- Grid container -->
            <!-- Grid container -->
            <!-- <div class="link">
              <div class="row m-0 no-gutters footer_div">
                <a href="#"> Privacy Policy</a> |
                <a href="#"> About Us</a> |
                <a href="#"> Terms & Conditions </a> |
                <a href="#"> Gambling can be addictive, Please play responsibly</a> |

              </div>
            </div> -->
            <!-- <div class="payment_infor">
              <p>Accept, process & disburse digital payments for your business.</p>
              <img style="width: 91%;" src="https://gamerswar.com/assets/images/social-icons/footer-logo.png"
                alt="Please waiting...">
            </div> -->
            <!-- Copyright -->
            <!-- <div *ngIf="this.logo != 'boomboombook'" class="text-center p-3"
              style="background-color: rgba(0, 0, 0, 0.2);">
              © 2022 Copyright:

              <a class="text-white" href="#">acepunt.in</a>
            </div> -->
            <!-- Copyright -->
          </footer>

          <!-- footerEnd -->

        </ng-container>

        <ng-container *ngIf="dataLength==0">
          <div class="text-warning text-center" style="margin-top:25vh;">No match</div>
        </ng-container>

      </div>

    </div>
    <div style="margin:50px;">

    </div>
    <div class="floating-btns ">
      <div class="btn-item">
        <div class="btn-wrap whatsapp" *ngIf="support?.whatsapp_support">
          <a href="{{support?.whatsapp_support}}"><img alt="WhatsApp"
              src="https://ss.manage63.com/bmk-wl/commonAssets/whatsapp-icon.svg"></a>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </mat-sidenav-content>

</mat-sidenav-container>


<button id="openModalButton" [hidden]="true" (click)="openDialog2(myModal)">Open Modal</button>
<ng-template #myModal>
  <div class="modal-body setbody">
    <mat-list class="setmat1">
      <!-- <div class="text-right"><a type="button" class="close1" data-dismiss="modal">
                    <mat-icon (click)="modalRefcancel.hide()">close</mat-icon>
                </a></div> -->
      <div class="text-right">
        <a type="button" class="close1" data-dismiss="modal">
          <mat-icon (click)="modalRefcancel.hide()">close</mat-icon>
        </a>
        <img style="width:100%" src="assets/images/offerpoint.png">
      </div>
    </mat-list>

  </div>
</ng-template>